import React from "react";
import "./SeoFooter.css";
import { Link } from "react-router-dom";

const seoLinks = [

              
  {
    title: "Aluminium Dealers in Muhammadabad Gohna",
    path: "/aluminium-window-works-muhammadabad-gohna",
  },
  {
    title: "Best Aluminium Window Dealers in Mau",
    path: "/aluminium-works-mau",
  },
  {
    title: "Best Aluminium Window Dealers in Ghosi",
    path: "/aluminium-works-ghosi",
  },
  {
    title: "Best Aluminium Window Dealers in Mubarakpur",
    path: "/aluminium-works-mubarakpu",
  },
  {
    title: "Best Aluminium Window Dealers in Azamgarh",
    path: "/aluminium-works-azamgarh",
  },
  {
    title: "Best Aluminium Window Dealers in Chiraiyakot",
    path: "/aluminium-works-chiraiyakot",
  },
];

const SeoFooter = () => {
  return (
    <footer className="seo-footer">
      <h2 className="seo-title">Best Aluminium Window Dealers</h2>

      <div className="seo-links">
        {seoLinks.map((item, index) => (
          <Link  onClick={() => window.scrollTo(0, 0)}
      style={{ textDecoration: "none" }}
            key={index}
            to={item.path}
            className="seo-link"
          >
            {item.title}
          </Link>
        ))}
      </div>
    </footer>
  );
};

export default SeoFooter;
